/** @format */

import React, { useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import PlatformIpPoolNumber from '../../../interfaces/platform/PlatformIpPoolNumber';
import GridItem from '../../../components/Grid/GridItem';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import { Computer } from '@material-ui/icons';
import { IpView } from './IpView';
import { IpStateSimpleHelper } from '../../lib/search/IpStateSimpleHelper';
import IpHistory from './IpHistory';

type IpDetailType = {
    handleSetBrandText: (text: string) => void;
};

export const IpDetail = ({ handleSetBrandText }: IpDetailType): React.ReactElement => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [ip, setIp] = useState<PlatformIpPoolNumber | null>(null);
    useEffect(() => {
        const itemLoader = new ItemLoaders(dispatch);
        const loadItems = (): void => {
            itemLoader.getWithCallback(
                FormGeneralHelper.getByUri('/' + id),
                'ip_details_view_get',
                (data: PlatformIpPoolNumber) => {
                    setIp(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        };
        if (!ip) {
            loadItems();
            handleSetBrandText('pools:ip.ip');
        }
    }, [dispatch, id, ip, handleSetBrandText]);

    const ipStateSimpleHelper = new IpStateSimpleHelper();

    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={6}>
                <Card>
                    <CardHeader icon={<Computer />} trans="pools:ip.ip" />
                    <CardBody>{ip && <IpView item={ip} ipStateHelper={ipStateSimpleHelper} />}</CardBody>
                </Card>
            </GridItem>
            {ip && (
                <GridItem xs={12} md={12}>
                    <IpHistory ip={ip} />
                </GridItem>
            )}
        </GridContainer>
    );
};
